import type { RootState } from 'store';

export const getCandidateListFilters = (state: RootState) => state.candidate.filter;
export const getCandidateCountries = (state: RootState) => state.candidate.settings.countries;
export const getCandidateCompanies = (state: RootState) => state.candidate.settings.companies;
export const getCandidateTags = (state: RootState) => state.candidate.settings.tags;
export const getCandidateSpecialities = (state: RootState) => state.candidate.settings.specialities;
export const getCandidateReminders = (state: RootState) => state.candidate.reminders;
export const getCandidateInteractions = (state: RootState) => state.candidate.interactions;
export const getCandidateRecruiters = (state: RootState) => state.candidate.recruiters;
export const getCandidateJobs = (state: RootState) => state.candidate.jobs;
export const getCandidateJobsLoading = (state: RootState) => state.candidate.jobsLoading;
export const getCandidateData = (state: RootState) => state.candidate.candidateData;
export const getCandidateTimeline = (state: RootState) => state.candidate.timeline;
export const getCandidateSources = (state: RootState) => state.candidate.sources;
